import { allpeepNoPayloadEndpoint, allpeepPayloadEndpoint } from './helpers.js';
export const reports = (rawClient) => ({
    list: allpeepNoPayloadEndpoint(rawClient, '/reports'),
    findById: allpeepNoPayloadEndpoint(rawClient, '/reports/:reportId'),
    create: allpeepPayloadEndpoint(rawClient, '/reports'),
    update: allpeepPayloadEndpoint(rawClient, '/reports/:id', 'patch'),
    delete: allpeepNoPayloadEndpoint(rawClient, '/reports/:id', 'delete'),
});
